import axios from 'axios'
import { useEffect, useState } from 'react'
import authService from '../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2,
  TitlePage3
} from '../../Components/Main'
import ProfileDireita from '../../Components/ProfileDireita'
import { NavDireita } from '../../Components/SideBar-right/SideBarDireita'
import SidebarMobile from '../../Components/SideBar-right/SidebarMobile'
import '../../styles/pages/MenuDireito/unidades.css'
import ModalCriar from './MenuDireito-Modal/ModalCadDocumento'
import Modal from './MenuDireito-Modal/ModalEdiDocumento'

function Documentos() {
  var user = authService.getCurrentUser()
  const [documentos, setDocumentos] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [modalInfo, setModalInfo] = useState([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/documentocliente/list/' +
          user[0].IdEmpresa +
          '/' +
          sessionStorage.IdUnidade +
          '/' +
          0
      )
      .then(response => {
        setDocumentos(response.data)
      })
  }, [])
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }
  function deleteDocumento(iddocumento: any) {
    if (window.confirm('Deletar documento?')) {
      axios
        .delete(
          process.env.REACT_APP_API_URL +
            '/api/v1/documentocliente/' +
            iddocumento
        )
        .then(response => {
          if (response.status === 200) {
            window.location.reload()
          } else {
            alert(response.data.message)
          }
        })
    }
  }
  const [modalOpen, setModalOpen] = useState(false)
  return (
    <div className="displayInteract">
      {modalOpen && <Modal setOpenModal={setModalOpen} modalInfo={modalInfo} />}
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>
        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>
              {sessionStorage.uniRazaoSocial} / DOCUMENTOS:
            </TitlePage1>
            {/* <TitlePage2>Unidade:</TitlePage2> */}
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <ModalCriar />
          </div>
        </div>
        <div className="tabelaPadrao">
          <table>
            <thead>
              <th>
                <p className="ttlTbl">Documento</p>
              </th>
              <th>
                <p className="ttlTbl">Validade</p>
              </th>
              <th>
                <p className="ttlTbl">Observação</p>
              </th>
              <th>
                <p className="ttlTbl">Status</p>
              </th>
            </thead>
            <tbody>
              {documentos
                .filter(val => {
                  if (searchTerm === '') {
                    return val
                  } else if (
                    val.dccUrl.toLowerCase().includes(searchTerm.toLowerCase())
                  ) {
                    return val
                  }
                })
                .map(documento => (
                  <tr key={documento.IdDocumentoCliente}>
                    <td>
                      <a href={documento.dccUrl} target="_blank">
                        <button className="btnDocDownload">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25px"
                            height="25px"
                            fill="currentColor"
                            className="bi bi-cloud-download"
                            viewBox="0 0 16 16"
                          >
                            <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z" />
                            <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z" />
                          </svg>
                          {/* {documento.dccUrl} */}
                        </button>
                      </a>
                    </td>
                    <td onClick={() => handleToggleComplete(documento)}>
                      {documento.dccValidade}
                    </td>
                    <td onClick={() => handleToggleComplete(documento)}>
                      <p className="Space2">{documento.dccObservacoes}</p>
                    </td>
                    <td>
                      <label
                        className="container"
                        onClick={() => handleToggleComplete(documento)}
                      >
                        <input
                          type="checkbox"
                          defaultChecked={!!documento.dccStatus}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                      <button
                        onClick={() =>
                          deleteDocumento(documento.IdDocumentoCliente)
                        }
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>
      <nav className="esconderFiltro">
        <ProfileDireita />
        <NavDireita />
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default Documentos
